export default {
  statusOptions(state) {
    return state.statusOptions;
  },
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  grupo(state) {
    return state.grupo;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.dataFinal,
      state.dataInicial,
      state.grupo && state.grupo.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = ['(situacaoCompra not in (\'CANCELADA\', \'RECUSADA\'))'];
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      filters.push(`(produto.descricao like '%${searchText}%' or produto.codigo like '%${searchText}%')`);
    }
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(state.selectedStatus.value());
    }
    if (state.dataInicial) {
      filters.push(`(dataPrevisaoEntrega >= ${state.dataInicial})`);
    }
    if (state.dataFinal) {
      filters.push(`(dataPrevisaoEntrega <= ${state.dataFinal})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(grupo => `(produto.categoria.id = ${grupo.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    return filters.join(' and ');
  },
};
